/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import {
  arrowLeftBlack,
  arrowRight,
  // closeIcon,
  emailIcon,
  orangeCalendarIcon,
} from 'assets/icons';
import moment from 'moment';
import {
  getSFTime,
  getSFTimeNew,
} from 'services/formatDateToTimezone/formatDateToTimezone';
import styles from './styles.module.css';
import Button from '../Button';
import { CircularProgress } from '@mui/material';
import MobileContext from 'context/MobileContext';

const MonthDatePickerNew = ({
  initialDate,
  search,
  searchButtonLabel,
  isStatement,
  secondaryAction,
  open,
  setOpen,
  loading,
  setloading,
}) => {
  const [date, setDate] = useState(initialDate);
  const [year, setYear] = useState(moment(initialDate).year());
  const options = moment.months();
  const isMobile = useContext(MobileContext);

  const isFutureMonth = (selectedYear, selectedMonth) => {
    const currentDate = moment().startOf('month');
    const selectedDate = moment(`${selectedYear}-${selectedMonth + 1}-01`).startOf(
      'month'
    );

    return selectedDate.isAfter(currentDate, 'day');
  };

  const handleMonthClick = month => {
    const selectedYear = year;
    const selectedMonth = month + 1;

    const selectedMonthPadded = selectedMonth < 10 ? `0${selectedMonth}` : selectedMonth;
    const selectedDate = `${selectedYear}-${selectedMonthPadded}-01`;
    if (!isFutureMonth(selectedYear, month)) {
      setDate(selectedDate);
    }
  };
  return (
    <div className={styles.container}>
      <div className={styles.input} onClick={() => setOpen(!open)}>
        <p className={styles.yearHeading}>
          <span style={{ fontFamily: 'Montserrat' }}>Year: </span>
          {moment(initialDate, 'YYYY-MM-DD').format('YYYY')}
        </p>
        <img
          style={{ width: isMobile ? 20 : 25, height: isMobile ? 20 : 25 }}
          src={orangeCalendarIcon}
          alt=""
        />
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={styles.modal}
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper elevation={0} className={styles.paper}>
            <div>
              <div className={styles.header}>
                <div className={styles.homeIconWrapper}>
                  <div className={styles.homeIcon}></div>
                </div>

                <div className={styles.headerAction}>
                  <div className={styles.popupYearHeading}>
                    <p>{year}</p>
                  </div>

                  <div className={styles.arrowWrapper}>
                    <img
                      style={{ marginRight: 20, color: '#969696' }}
                      src={arrowLeftBlack}
                      alt=""
                      onClick={() => setYear(year - 1)}
                    />
                    <img
                      src={arrowRight}
                      alt=""
                      onClick={() => setYear(year + 1)}
                      style={
                        +year === +moment().year()
                          ? { pointerEvents: 'none', opacity: 0.5 }
                          : {}
                      }
                      className={+year === +moment().year() ? styles.disabledArrow : ''}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.content}>
                {options.map((el, i) => {
                  return (
                    <div
                      key={`${el}-${year}`}
                      className={`${styles.month} ${+moment(date).year() === year &&
                        +moment(date).month() + 1 === i + 1 &&
                        styles.activeMonth} ${isFutureMonth(year, i) &&
                        styles.disabledMonth}`}
                      onClick={() => handleMonthClick(i)}
                      onTouchEnd={() => handleMonthClick(i)}
                    >
                      {el}
                    </div>
                  );
                })}
              </div>
              <div className={styles.button}>
                {search && (
                  <Button
                    onClick={() => {
                      search(date);
                      setOpen(false);
                    }}
                    className={styles.buttonEl}
                  >
                    {searchButtonLabel}
                  </Button>
                )}
                {isStatement && (
                  <div className={styles.buttonDiv}>
                    {loading ? (
                      <CircularProgress size={30} style={{ color: '#fe5000' }} />
                    ) : (
                      <img
                        alt=""
                        width={isMobile ? 22 : 32}
                        height={isMobile ? 22 : 32}
                        src={emailIcon}
                      />
                    )}
                    <div
                      styleType="tertiary"
                      onClick={() => {
                        secondaryAction(date);
                        setloading(true);
                      }}
                      className={styles.statementButton}
                    >
                      Email PDF
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
};

MonthDatePickerNew.propTypes = {
  initialDate: PropTypes.string.isRequired,
  search: PropTypes.func.isRequired,
  isStatement: PropTypes.bool,
  secondaryAction: PropTypes.func,
  searchButtonLabel: PropTypes.string,
};
MonthDatePickerNew.defaultProps = {
  isStatement: false,
  searchButtonLabel: 'Search',
  secondaryAction: () => {},
};
export default MonthDatePickerNew;
